import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lotoro from "./Lotoro";
import Terms from "./Terms"; // ✅ Import Terms page
import { logFrontendError } from "./utils/logger";
import { Global } from "@emotion/react";

const AdminPage = lazy(() => import("./admin"));

function App() {
  useEffect(() => {
    window.onerror = (msg, url, line, col, error) => {
      logFrontendError(`${msg} at ${url}:${line}:${col}`, error?.stack || "");
    };

    window.onunhandledrejection = (event) => {
      logFrontendError(
        `Unhandled Rejection: ${event.reason?.message || event.reason}`,
        event.reason?.stack || ""
      );
    };
  }, []);

  return (
    <>
      <Global
        styles={`
          html, body, #root {
            height: 100%;
            overflow-x: hidden;
          }

          body {
            overflow-y: auto;
            overscroll-behavior-y: none;
          }

          @media (max-width: 768px) {
            html, body, #root {
              height: auto;
              max-height: none;
              overflow-y: auto;
            }
          }
        `}
      />
      <BrowserRouter>
        <Routes>
          <Route
            path="/admin/*"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <AdminPage />
              </Suspense>
            }
          />
          <Route path="/terms" element={<Terms />} /> {/* ✅ New Terms route */}
          <Route path="*" element={<Lotoro />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
